import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import { useAuth } from '../utils/AuthProvider';

const Header = ({ history }) => {
  const { isAuth, user, removeToken } = useAuth();

  const { givenName, name } = user || {};

  const userName = givenName || name;

  const handleLogout = () => {
    removeToken();
    history.push('/login');
  };

  return (
    <div className="flex h-16 w-full bg-black p-4 align-center justify-between fixed pin-t pin-l z-top">
      <div className="flex items-center">
        <Link to="/cms"><span className="text-grey-avatar icon-ps-logo-small font-icon text-4xl" /></Link>
        {userName && (
          <span className="text-white text-sm pl-4">
            {`Hello ${userName}! `}
            <span role="img" aria-label="wave">👋</span>
          </span>
        )}
      </div>
      <div className="flex items-center">
        {isAuth && (
          <>
            <span className="font-icon icon-close-btn1 text-20 text-red" />
            <a className="text-white text-xs font-americaMonoRegular uppercase pl-2 pr-4 cursor-pointer font-bold" onClick={handleLogout}>Logout</a>
          </>
        )}
      </div>
    </div>
  );
}

Header.propTypes = {
  history: PropTypes.shape().isRequired,
};

export default withRouter(Header);
